// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"57":"a8555885","787":"26623f6d"}[chunkId] + ".chunk.js";
};